<rt-box variant="no-padding">
  <div
    class="field-mapping-form-field-mapping-container"
    layout
    layout-space-between
    layout-align-items-center
  >
    <div layout layout-align-items-center>
      <rt-icon name="drag-vertical" />
      <rt-icon [name]="icon" margin-lr-small-x />
      {{ title }}
    </div>

    <rt-icon-button (click)="delete()" variant="plain" size="small" iconName="close" />
  </div>
</rt-box>
